import { render, staticRenderFns } from "./Projeler.vue?vue&type=template&id=31967450&scoped=true&"
import script from "./Projeler.vue?vue&type=script&lang=js&"
export * from "./Projeler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31967450",
  null
  
)

export default component.exports